import React from 'react';

import QuestionShell from '../QuestionShell';
import useQuestionForm from '../QuestionShell/useQuestionForm';

function Audio({
  identifier, pages, info, handleDeleteQuestion, handleDuplicateQuestion, mode,
}) {
  const question = useQuestionForm({ identifier, pages, info });

  return (
    <QuestionShell
      {...question}
      identifier={identifier}
      info={info}
      mode={mode}
      titleKey="task.taskEdition.audioText.title"
      descriptionKey="task.taskEdition.audioText.description"
      handleDeleteQuestion={handleDeleteQuestion}
      handleDuplicateQuestion={handleDuplicateQuestion}
    />
  );
}

export default Audio;
